import styled from 'styled-components';
import { Button } from '@material-ui/core';

// CONSTANTS
import colors, { WHITE, TRANSPARENT } from '@/constants/colors';

export const Wrapper = styled.div`
  .collapsable-container,
  &.collapsable-container {
    background-color: ${WHITE};
    width: 100%;
    transition: all 0.4s;
    border-radius: 8px;

    &--shadow {
      &:hover {
        box-shadow: 0 30px 60px ${colors.appCard.hover.shadow};
      }
    }

    p + ol,
    p + ul {
      margin-top: 10px;
    }

    p + p {
      margin-bottom: 10px;
    }
  }
`;

export const ButtonStyled = styled(Button)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-radius: 8px;

    padding: 24px 40px;

    h6,
    i {
      transition: all 0.4s;
    }

    h6 {
      text-align: left;
      padding-right: 20px;
    }

    &:hover {
      color: ${p => p.theme.palette.primary.main};
      background-color: ${TRANSPARENT};
    }
  }
`;

export const Container = styled.div`
  padding: 0 40px 24px;
`;

export default Wrapper;
